import axios from "axios";

const {
  REACT_APP_ACTION_SOCIALE_API_URL,
  REACT_APP_BAREMES_API_URL,
  REACT_APP_ACTION_SOCIALE_BY_DLG_CAS_API_URL,
  REACT_APP_JUSTIFICATIF_FOR_NOTICEINFO_API_URL,
  REACT_APP_IBAN_MEMBRE_URL,
  REACT_APP_CODE_BANQUE_API_URL,
  REACT_APP_BAREMES_CESU_API_URL,
  REACT_APP_INTERVAL_AGE_ENF_CESU_API_URL,
  REACT_APP_BAREMES_CESU_MULTI_API_URL
} = process.env;


export class ClapService {

  getActionSocialDemat(codeDeleg) {
    const header = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "true",
    };
    return axios.get(REACT_APP_ACTION_SOCIALE_API_URL, {
      params: {
        codeDelegation: codeDeleg,
      },

      headers: header,
      withCredentials: "omit",
    });
  }


  getActionSocialDematByDlgCas(codeDeleg, codeActionSociale) {
    const header = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "true",
    };
    return axios.get(REACT_APP_ACTION_SOCIALE_BY_DLG_CAS_API_URL, {
      params: {
        codeDelegation: codeDeleg,
        codeCas: codeActionSociale,
      },

      headers: header,
      withCredentials: "omit",
    });
  }

  getBaremes(bareme) {
    const header = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "true",
    };
    return axios.get(REACT_APP_BAREMES_API_URL, {
      params: {
        exercie: bareme.exercie,
        casCode: bareme.casCode,
        delegId: bareme.delegId,
        siActif: bareme.siActif,
      },

      headers: header,
      withCredentials: "omit",
    });
  }

  getJustificatifForClapNoticeInfo(numCgos, codeSituationAdmin, codePosition) {
    const header = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "true",
    };
    return axios.get(REACT_APP_JUSTIFICATIF_FOR_NOTICEINFO_API_URL, {
      params: {
        numeroCgos: numCgos,
        codeSituationAdministrative: codeSituationAdmin,
        codePosition: codePosition,
      },

      headers: header,
      withCredentials: "omit",
    });
  }

  getIbanMembre(numCgos) {
    const header = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "true",
    };
    return axios.get(REACT_APP_IBAN_MEMBRE_URL, {
      params: {
        numCgos: numCgos,
      },

      headers: header,
      withCredentials: "omit",
    });
  }

  getBaremesCesu(bareme) {
    const header = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "true",
    };
    return axios.get(REACT_APP_BAREMES_CESU_API_URL, {
      params: {
        exercice: bareme.exercice,
        casCode: bareme.casCode
      },

      headers: header,
      withCredentials: "omit",
    });
  }
  

  getIntervalleEnfantsCesu(bareme) {
    const header = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "true",
    };
    return axios.get(REACT_APP_INTERVAL_AGE_ENF_CESU_API_URL, {
      params: {
        exercice: bareme.exercice,
        dlgId: bareme.delegId,
        casCode: bareme.casCode
      },

      headers: header,
      withCredentials: "omit",
    });
  }

  
  getBaremesCesuMulti(bareme) {
    const header = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "true",
    };
    return axios.get(REACT_APP_BAREMES_CESU_MULTI_API_URL, {
      params: {
        exercice: bareme.exercice,
      },

      headers: header,
      withCredentials: "omit",
    });
  }


}
